export enum BannerVariant {
  INFORMATIVE = "informative",
  ERROR = "error",
  WARNING = "warning",
  SUCCESS = "success",
}
